import { render, staticRenderFns } from "./records.vue?vue&type=template&id=1732fcea&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"
import style0 from "./records.vue?vue&type=style&index=0&id=1732fcea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732fcea",
  null
  
)

export default component.exports